<div class="container single-view" id="edit-inventory">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" appBack [fallbackUrl]="'/inventories/' + inventoryId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'INVENTORIES.BTN_BACK_TO_INVENTORY' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr">
        <div class="title-wr">
          <h1 data-testid="edit-inventory-title" class="section-title">{{ 'INVENTORY_UPDATE.TITLE' | translate }}</h1>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="inventoryForm" data-testid="edit-inventory-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="edit-inventory-details" class="border-b pb-3">{{ 'INVENTORY_UPDATE.INVENTORY_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="edit-inventory-field-reference" class="block text-sm" for="referenceControl">{{ 'INVENTORY_UPDATE.INVENTORY_REFERENCE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="edit-inventory-reference-input" type="text" formControlName="referenceControl" autocomplete="off">
                  @if (inventoryForm.get('referenceControl')?.invalid && inventoryForm.get('referenceControl')?.touched) {
                    <small data-testid="reference-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 disabled">
                  <label data-testid="edit-inventory-field-retailer" class="block text-sm" for="retailerControl">{{ 'INVENTORY_UPDATE.RETAILER' | translate }}</label>
                  <input data-testid="edit-inventory-retailer-input" type="text" [disabled]="true" formControlName="retailerControl" autocomplete="off">
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-3 col-lg-6 col-xl-3 disabled">
                  <label data-testid="edit-inventory-field-brand" class="block text-sm" for="brandControl">{{ 'PRODUCT_UPDATE.BRAND' | translate }}</label>
                  <input data-testid="edit-inventory-brand-input" type="text" [disabled]="true" formControlName="brandControl" autocomplete="off">
                </div>
                <div class="field-wr flex flex-col col-12">
                  <label data-testid="edit-inventory-field-comments" class="block text-sm" for="commentControl">{{ 'INVENTORY_UPDATE.COMMENTS' | translate }}</label>
                  <textarea data-testid="edit-inventory-comments-input" type="text" formControlName="commentControl" autocomplete="off"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="edit-inventory-update-inventory-button" class="btn primary-btn" [disabled]="inventoryForm.invalid"
                    (click)="submitForm()">{{ 'INVENTORY_UPDATE.BTN_UPDATE_INVENTORY' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
